<template>
    <el-dialog
        title=""
        :visible.sync="dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="456px"
        center>
        <div class="yijing-container flex flex-direction">
            <div class="title self-center">紧急预警</div>
            <div class="classify margin-tb-sm">
                <i class="icon iconfont icon-jinggao"></i>
                {{ detail.service_type|service_type }}
            </div>
            <div class="info">{{ detail.xiaoqu_name }}
                <span v-if="detail.show_address">{{ detail.building_name}}{{ detail.element_name }}单元{{ detail.room_name }}</span>
                <span v-else @click="detail.show_address = true">****</span>
            </div>
            <div class="info margin-top-xs">{{ detail.name }} |
                <span v-if="detail.show_phone">{{ detail.phone }}</span>
                <span v-else @click="detail.show_phone = true">{{ detail.phone | formatPhone }}</span>
            </div>
            <div class="tips self-center margin-top-sm">———— 请立即联系监测对象 ————</div>
            <el-button class="operate margin-top-sm self-center" :loading="loading" @click="sureSet">已处理</el-button>
        </div>
    </el-dialog>
</template>

<script>

import {formatPhone, zhDate} from "@/utils/utils";
import {setSaveState} from "@/api/tongji";

export default {
    name: "YijingDialog",
    data() {
        return {
            loading:false
        }
    },
    props: {
        dialog: {
            type: Boolean,
            default: false
        },
        detail: {
            type: [String, Object],
            default: ''
        }
    },
    computed: {},
    methods: {
        async sureSet() {
            this.loading = true
            let _state = await setSaveState(this.detail.id)
            this.loading = false
            if (_state.status === 200) {
                this.$message.success(_state.info);
                this.$emit('cancelDialog', true)
            }else {
                this.$message.error(_state.info);
            }
        },
        //  取消
        reset() {
            this.$emit('cancelDialog', false)
        },
    },
    watch: {},
    filters: {
        date_time(val) {
            return zhDate(val, 8)
        },
        service_type(val) {
            switch (Number(val)) {
                case 1 :
                    return '主动求救'
                case 2 :
                    return '心率异常'
                case 3 :
                    return '体温异常'
                case 4 :
                    return '血糖异常'
                case 5 :
                    return '血氧异常'
                case 6 :
                    return '血压异常'
            }
        },
        formatPhone(val) {
            return formatPhone(val)
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ {
    .el-dialog {
        background-image: linear-gradient(0deg,
            #0c5da3aa 0%,
            #002262aa 100%),
        linear-gradient(
                #002262aa,
                #002262aa);
        background-blend-mode: normal,
        normal;

        .el-dialog__header {
            display: none;
        }

        .el-dialog__body {
            padding: 0;
        }

    }

    .yijing-container {
        padding: 0 57px 30px;

        .title {
            background: url(../../../assets/img/data/bg_monitoring_title.png) no-repeat top;
            background-size: 100% 100%;
            width: 242px;
            height: 41px;
            line-height: 41px;
            text-align: center;
            font-size: 18px;
            font-weight: 600;
            color: #ff3a3a;
        }

        .classify {
            height: 60px;
            line-height: 60px;
            text-align: center;
            background-color: #df3030;
            border-radius: 5px;
            font-size: 24px;
            font-weight: 600;
            color: #ffffff;

            .icon {
                font-size: 27px;
                color: #ffd200;
            }
        }

        .info {
            font-size: 18px;
            color: #ffffff;
        }

        .tips {
            font-size: 18px;
            color: #ffd200;
        }

        .operate {
            width: 144px;
            height: 43px;
            line-height: 43px;
            text-align: center;
            padding: 0;
            border: none;
            background-image: linear-gradient(0deg,
                #198bff 0%,
                #19caff 100%),
            linear-gradient(
                    #27447d,
                    #27447d);
            background-blend-mode: normal,
            normal;
            border-radius: 22px;
            font-size: 18px;
            color: #ffffff;
            cursor: pointer;
        }
    }
}
</style>